import { render, staticRenderFns } from "./Surgries.vue?vue&type=template&id=9d653d04&"
import script from "./Surgries.vue?vue&type=script&lang=js&"
export * from "./Surgries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports